import {
  ApiUpdateUserRequest,
  ApiUser,
  ApiUserSignupRequest,
} from '@repo/types';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useApi } from './useApi';
import { useQueryKeys } from '@src/hooks/useQueryKeys';

export function useGetUser(enabled: boolean = true) {
  const api = useApi();
  const queryKey = useQueryKeys(['user']);
  const fetchUser = async () => {
    const response = await api.get('/users/current');
    const user = (await response?.json()) as ApiUser;
    return user;
  };

  return useQuery(queryKey, fetchUser, {
    staleTime: 10 * 60 * 1000, // 10 minutes,
    enabled,
  });
}

export function useSignupUser() {
  const api = useApi();
  const queryClient = useQueryClient();
  const userQueryKey = useQueryKeys(['user']);

  const signupUser = async (data: ApiUserSignupRequest) => {
    await api.post('/users/sign-up', data, { skipAuth: true });
  };

  return useMutation({
    mutationFn: signupUser,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: userQueryKey });
    },
  });
}

export function useUpdateUser() {
  const api = useApi();
  const queryClient = useQueryClient();
  const userQueryKey = useQueryKeys(['user']);
  const universityStatsQueryKey = useQueryKeys(['university-stats']);

  const updateUser = async (data: ApiUpdateUserRequest) => {
    await api.patch('/users', data);
  };

  return useMutation({
    mutationFn: updateUser,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: userQueryKey });
      queryClient.invalidateQueries({ queryKey: universityStatsQueryKey });
    },
  });
}
